export default __webpack_public_path__ + "static/media/flag-luxembourg.d290ce43.svg";